import React from "react"
import { formatDate } from "@ui-seeker/utils"
import { Box, Typography } from "@mui/material"
import {dateFormatReceiver} from "@utils";


export default function searchDateColumn() {

    return {
        name: "timestamp_create_user",
        label: "Date of Search",
        options: {
            filter: false,
            customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                <Typography sx={{ p: 1, fontSize: 14 }}>
                    {formatDate(value, {
                        isString: true,
                        format: "dd MMM yyyy",
                        receivedFormat: dateFormatReceiver(value)
                    })}
                </Typography>
            </Box>
        }
    }
}